import type {
  FilterGroup,
  FilterInput,
} from '@/components/publicSearch/constants';
import { hasFilterCriteria } from '@/hooks/publicSearch/hasFilterCriteria';

/**
 * Members Enquiry requires a search, like Animal Enquiry: no default listing
 * of every member. Any complete filter (quick search, basic or advanced) counts.
 */
export function hasMemberSearchCriteria(
  filters: FilterInput[],
  filterGroups: FilterGroup[],
): boolean {
  return hasFilterCriteria(filters, filterGroups);
}
